"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = reducer;
exports.clearTaskTimeLogID = exports.selectTaskTimeLogID = exports.handleNoSelectedEntity = exports.selectLanguage = exports.selectEntityProfileID = exports.selectEntityID = exports.clearEntityIDS = exports.setManualFlow = exports.ACTIONS = void 0;

var _ = require(".");

var _constants = require("../constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  isManualFlow: false,
  selectedEntityID: null,
  entityProfileID: null,
  taskTimeLogID: null,
  selectedLanguage: _constants.userLanguages.RO.value
};
var ACTIONS = {
  SELECT_ENTITY_ID: new _.Action('SELECT_ENTITY_ID'),
  SELECT_ENTITY_PROFILE_ID: new _.Action('SELECT_ENTITY_PROFILE_ID'),
  CLEAR_ENTITY_IDS: new _.Action('CLEAR_ENTITY_IDS'),
  NO_SELECTED_ENTITY: new _.Action('NO_SELECTED_ENTITY'),
  SET_MANUAL_FLOW: new _.Action('SET_MANUAL_FLOW'),
  SELECT_TASK_TIME_LOG_ID: new _.Action('SELECT_TASK_TIME_LOG_ID'),
  CLEAR_TASK_TIME_LOG_ID: new _.Action('CLEAR_TASK_TIME_LOG_ID'),
  SELECT_LANGUAGE: new _.Action('SELECT_LANGUAGE')
};
exports.ACTIONS = ACTIONS;

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case ACTIONS.SET_MANUAL_FLOW.main:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isManualFlow: action.payload.value
        });
      }

    case ACTIONS.SELECT_ENTITY_ID.main:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          selectedEntityID: action.payload.entityID
        });
      }

    case ACTIONS.SELECT_ENTITY_PROFILE_ID.main:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          entityProfileID: action.payload.entityProfileID
        });
      }

    case ACTIONS.CLEAR_ENTITY_IDS.main:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          selectedEntityID: null,
          entityProfileID: null
        });
      }

    case ACTIONS.SELECT_TASK_TIME_LOG_ID.main:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          taskTimeLogID: action.payload.taskTimeLogID
        });
      }

    case ACTIONS.CLEAR_TASK_TIME_LOG_ID.main:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          taskTimeLogID: null
        });
      }

    case ACTIONS.SELECT_LANGUAGE.main:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          selectedLanguage: action.payload.language
        });
      }

    default:
      return state;
  }
}

var setManualFlow = function setManualFlow(value) {
  return {
    type: ACTIONS.SET_MANUAL_FLOW.main,
    payload: {
      value: value
    }
  };
};

exports.setManualFlow = setManualFlow;

var clearEntityIDS = function clearEntityIDS() {
  return {
    type: ACTIONS.CLEAR_ENTITY_IDS.main
  };
};

exports.clearEntityIDS = clearEntityIDS;

var selectEntityID = function selectEntityID(entityID) {
  return {
    type: ACTIONS.SELECT_ENTITY_ID.main,
    payload: {
      entityID: entityID
    }
  };
};

exports.selectEntityID = selectEntityID;

var selectEntityProfileID = function selectEntityProfileID(entityProfileID) {
  return {
    type: ACTIONS.SELECT_ENTITY_PROFILE_ID.main,
    payload: {
      entityProfileID: entityProfileID
    }
  };
};

exports.selectEntityProfileID = selectEntityProfileID;

var selectLanguage = function selectLanguage(language) {
  return {
    type: ACTIONS.SELECT_LANGUAGE.main,
    payload: {
      language: language
    }
  };
};

exports.selectLanguage = selectLanguage;

var handleNoSelectedEntity = function handleNoSelectedEntity() {
  return {
    type: ACTIONS.NO_SELECTED_ENTITY.main
  };
};

exports.handleNoSelectedEntity = handleNoSelectedEntity;

var selectTaskTimeLogID = function selectTaskTimeLogID(taskTimeLogID) {
  return {
    type: ACTIONS.SELECT_TASK_TIME_LOG_ID.main,
    payload: {
      taskTimeLogID: taskTimeLogID
    }
  };
};

exports.selectTaskTimeLogID = selectTaskTimeLogID;

var clearTaskTimeLogID = function clearTaskTimeLogID() {
  return {
    type: ACTIONS.CLEAR_TASK_TIME_LOG_ID.main
  };
};

exports.clearTaskTimeLogID = clearTaskTimeLogID;